import { render, staticRenderFns } from "./StockListFilters.vue?vue&type=template&id=49a2593c&scoped=true&"
import script from "./StockListFilters.vue?vue&type=script&lang=js&"
export * from "./StockListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2593c",
  null
  
)

export default component.exports